import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthApi } from '../auth/auth-api';
import { AppRoutes } from '../app.routes';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthApi);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  router.navigate([AppRoutes.LOGIN]);
  return false;
};
